import React from "react";
import { useState, useEffect } from "react";
import AddDealer from "./AddDealer";
import AddOwner from "./AddOwner";
import AddCars from "./AddCars";
import AddImages from "./AddImages";
import ValueSender from "./ValueSender";
import { useAddNewInventoryMutation } from "state/api";
import DefaultCase from "./DefaultCase";

const AddInventory = (props) => {
  const { AfterSubmit, AfterFailure, CloseModal } = props;
  const [AddInventory] = useAddNewInventoryMutation();
  const values_to_send = {
    name: "",
    model: "",
    registrationType: "",
    ownerSerial: "",
    yearOfManufacture: "",
    variant: "",
    color: "",
    fuelType: "",
    insuranceExpiryDate: "",
    registrationExpiryDate: "",
    registrationDate: "",
    kmsDriven: "",
    price: "",
    chassisNumber: "",
    inventoryType: "",
    engineNumber: "",
    vehicleNumber: "",
    dealerName: "",
    dealerAddress: "",
    dealerEmail: "",
    dealerContact: "",
    ownerName: "",
    ownerAddress: "",
    ownerEmail: "",
    ownerContact: "",
    image: [],
    thumbnail: null,
    transmission: "",
  };
  const [Values, setValues] = useState(values_to_send);
  const [Step, setStep] = useState(1);
  const [Submitted, setSubmitted] = useState(false);

  const nextStep = () => {
    let StepsToFollow = {};
    if (Values.inventoryType === "Dealer's Stock") {
      StepsToFollow = {
        1: 2,
        2: 3,
        3:4,
        4: 5,
      };
    } else {
      StepsToFollow = {
        1: 3,
        3: 4,
        4: 5,
        2: 5,
      };
    }

    setStep(StepsToFollow[Step]);
  };

  const prevStep = () => {
    let StepsToFollowBack = {};
    if (Values.inventoryType === "Dealer's Stock") {
      StepsToFollowBack = {
        4: 3,
        2: 1,
        3: 2,
        1: 0,
      };
    } else {
      StepsToFollowBack = {
        4: 3,
        3: 1,
        2: 1,
        1: 0,
      };
    }
    setStep(StepsToFollowBack[Step]);
  };
  const handleSubmit = () => {
    setSubmitted(true);
  };

  useEffect(() => {
    async function Submitter() {
      if (Submitted) {
        if (Step === 4) {
          CloseModal();
          const tosendval = ValueSender(Values);
          await AddInventory(tosendval)
            .unwrap()
            .then((res) => {
              AfterSubmit();
            })
            .catch((err) => {
              AfterFailure();
            })
            .finally(() => {
              // reset Values state
              for (const key in Values) {
                Values[key] = "";
              }
              Values.image = [];
              Values.thumbnail = null;
            });
        } else {
          nextStep();
          setSubmitted(false);
        }
      }
    }
    Submitter();
  }, [Submitted]);

  switch (Step) {
    case 0:
      return <DefaultCase />;

    case 1:
      return <AddCars Values={Values} handleSubmit={handleSubmit} />;

    case 2:
      return (
        <AddDealer
          prevStep={prevStep}
          Values={Values}
          handleSubmit={handleSubmit}
        />
      );

    case 3:
      return (
        <AddOwner
          prevStep={prevStep}
          Values={Values}
          handleSubmit={handleSubmit}
        />
      );

    case 4:
      return (
        <AddImages
          Values={Values}
          prevStep={prevStep}
          handleSubmit={handleSubmit}
        />
      );

    default:
      return <DefaultCase />;
  }
};

export default AddInventory;
